<template>
  <v-col cols="11" class="pa-0">
    <div class="d-flex align-center">
      <div class="mr-3">
        <v-avatar size="28" class="mr-2" :color="randomColor(review)">
          <span class="white--text text-caption">{{ initials(review) }}</span>
        </v-avatar>
      </div>
      <div>
        <div>{{ review.fullName }}</div>
        <div v-if="fullStarsCount > 3">
          <v-icon
            x-small
            v-for="s in fullStarsCount"
            :key="s"
            class="mr-2"
            color="yellow darken-2"
            >fas fa-star</v-icon
          >
          <v-icon
            :small="isMobileOrIPad"
            v-if="hasHalfStar"
            color="yellow darken-2"
            >fas fa-star-half</v-icon
          >
        </div>
      </div>
    </div>
    <div class="mt-4">
      <span v-if="!expanded" class="text-body-2 font-weight-regular">{{
        truncatedBody
      }}</span>
      <span v-else class="text-body-2 font-weight-regular">{{
        review.public
      }}</span>

      <span
        v-if="needsTruncate"
        class="text-decoration-underline grey--text text--darken-2 cursor-pointer ms-1 text-caption"
        @click="toggle"
      >
        {{ expanded ? "show less" : "show more" }}
      </span>
      <div class="text-caption grey--text mb-2">
        {{ formattedDate }} ({{ review.source }})
      </div>
    </div>
  </v-col>
</template>

<script>
import moment from "moment";

export default {
  name: "ListingReview",
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      expanded: false,
      TRUNCATE_AT: 140,
    };
  },
  computed: {
    score() {
      return +(this.review.normilized_scrore_overall / 2).toFixed();
    },
    formattedDate() {
      return moment(this.review.created_at).format("MMM D, YYYY");
    },
    needsTruncate() {
      return this.review.public && this.review.public.length > this.TRUNCATE_AT;
    },
    truncatedBody() {
      if (!this.needsTruncate) return this.review.public;
      return `${this.review.public.slice(0, this.TRUNCATE_AT)}...`;
    },
    fullStarsCount() {
      return Math.floor(this.score);
    },
    hasHalfStar() {
      return this.score % 1 !== 0;
    },
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },
    randomColor(review) {
      if (!review || !review.fullName) return "primary";
      // Simple hash to pick a color from Vuetify palette
      const colors = [
        "deep-purple accent-4",
        "indigo darken-2",
        "teal darken-2",
        "cyan darken-2",
        "green darken-2",
        "orange darken-2",
        "blue darken-2",
        "red darken-2",
        "pink darken-2",
        "amber darken-2",
      ];
      let hash = 0;
      for (let i = 0; i < review.fullName.length; i++) {
        hash = review.fullName.charCodeAt(i) + ((hash << 5) - hash);
      }
      const idx = Math.abs(hash) % colors.length;
      return colors[idx];
    },
    initials(review) {
      if (!review || !review.fullName) return "";
      const names = review.fullName.trim().split(" ");
      if (names.length === 1) return names[0][0].toUpperCase();
      return (
        names[0][0].toUpperCase() +
        (names[names.length - 1][0]
          ? names[names.length - 1][0].toUpperCase()
          : "")
      );
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
